/*import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)*/

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../components/home.vue')
  },
  {
    path: '/novo_plano/:id/:tipo',
    name: 'NovoPlano',
    component: () => import('../components/novo_plano.vue')
  },
  {
    path: '/atas',
    name: 'atas',
    component: () => import('../components/atas.vue')
  },
  {
    path: '/atas/:codigo',
    name: 'ver_atas',
    component: () => import('../components/ata_detalhes.vue')
  },
  {
    path: '/fechamento',
    name: 'fechamento',
    component: () => import('../components/fechamento_periodo.vue')
  },
  {
    path: '*',
    name: 'construcao',
    component: () => import('../components/em_construcao.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../components/dashboard.vue')
  },
  {
    path: '/hotsite/:slug/:opcao/:id',
    name: 'Compras',
    component: () => import('../components/hotsite_compras.vue')
  },
  {
    path: '/orcamento',
    name: 'Orcamento',
    component: () => import('../components/orcamento.vue')
  },
  {
    path: '/hotsite',
    name: 'hotsite',
    component: () => import('../components/hotsite.vue')
  },
  {
    path: '/fluxo_de_caixa',
    name: 'Fluxo',
    component: () => import('../components/fluxo.vue')
  },
  {
    path: '/meu_titulo',
    name: 'Meu_titulo',
    component: () => import('../components/meu_titulo.vue')
  },
  {
    path: '/minhas_mensagens',
    name: 'minhas_mensagens',
    component: () => import('../components/minhas_mensagens.vue')
  },
  {
    path: '/meus_documentos',
    name: 'meus_documentos',
    component: () => import('../components/documentos.vue')
  },
  {
    path: '/meus_eventos',
    name: 'meus_eventos',
    component: () => import('../components/Meus_eventos.vue')
  },
  {
    path: '/meus_eventos/participantes/:id',
    name: 'meus_eventos_participantes',
    component: () => import('../components/evento_participantes.vue')
  },
  {
    path: '/meus_eventos/compras/:id',
    name: 'meus_eventos_compras',
    component: () => import('../components/evento_compras.vue')
  },
  {
    path: '/meus_reembolsos',
    name: 'meus_reembolsos',
    component: () => import('../components/Meus_reembolsos.vue')
  },
  {
    path: '/documentos',
    name: 'Documentos',
    component: () => import('../components/documentos.vue')
  },
  {
    path: '/eventos',
    name: 'Eventos',
    component: () => import('../components/eventos.vue')
  }, {
    path: '/eventos/detalhes/imagens/:id',
    name: 'Imagens',
    component: () => import('../components/evento_imagens.vue')
  },
  {
    path: '/eventos/detalhes/:id',
    name: 'Detalhes',
    component: () => import('../components/evento_detalhes.vue')
  },
  {
    path: '/eventos/compras/:id',
    name: 'eventosCompras',
    component: () => import('../components/evento_compras.vue')
  },
  {
    path: '/eventos/detalhes/participantes/:id',
    name: 'Participantes',
    component: () => import('../components/evento_participantes.vue')
  },
  {
    path: '/eventos/detalhes/ingressos/:id',
    name: 'Ingressos',
    component: () => import('../components/evento_ingressos.vue')
  },
  {
    path: '/eventos/detalhes/atividades/:id',
    name: 'Atividades',
    component: () => import('../components/evento_atividades.vue')
  },
  {
    path: '/eventos/detalhes/vendas/:id',
    name: 'Vendas',
    component: () => import('../components/evento_vendas.vue')
  },
  {
    path: '/categorias',
    name: 'Categorias',
    component: () => import('../components/categorias.vue')
  },
  {
    path: '/contas',
    name: 'Conta',
    component: () => import('../components/contas.vue')
  },
  {
    path: '/associados',
    name: 'Associado',
    component: () => import('../components/associados.vue')
  },
  {
    path: '/entidades',
    name: 'Entidades',
    component: () => import('../components/entidades.vue')
  },
  {
    path: '/planos',
    name: 'Planos',
    component: () => import('../components/planos.vue')
  },
  {
    path: '/emails',
    name: 'E-mails',
    component: () => import('../components/emails.vue')
  },
  {
    path: '/grupos',
    name: 'Grupos',
    component: () => import('../components/user_grupos.vue')
  },
  {
    path: '/classificacoes',
    name: 'Classificacoes',
    component: () => import('../components/classificacoes.vue')
  },
  {
    path: '/meus_dados',
    name: 'meusDados',
    component: () => import('../components/meus_dados.vue')
  },
  {
    path: '/reembolsos',
    name: 'reembolsos',
    component: () => import('../components/reembolsos.vue')
  },
  {
    path: '/grupo_familiar',
    name: 'grupoFamiliar',
    component: () => import('../components/grupo_familiar.vue')
  },
  {
    path: "/:clubeSlug",
    name: 'Login',
    props: true,
    component: () => import('../components/login.vue')
  },
  {
    //path: '/login',
    path: "/:clubeSlug/:userToken",
    name: 'FirstLogin',
    props: true,
    component: () => import('../components/first_login.vue')
  },
  {
    //path: '/login',
    path: "/r/:clubeSlug/:userToken",
    name: 'RecuperarSenha',
    props: true,
    component: () => import('../components/first_login.vue')
  },
]

/*const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes

})*/

export default routes
